import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { SuiStateButton, STATUS_READY, STATUS_LOADING } from '@splashthat/sui';

import { DEFAULT_BUTTON_POSITION } from 'common/entities/form/styleConfiguration/defaultValues';
import { LEFT, CENTER, RIGHT, FULL } from 'common/entities/form/styleConfiguration/constants';
import { getButtonPosition } from 'common/entities/form/styleConfiguration/selectors';
import { getFormSubmitting } from '../../selectors/form';

import SanitizedHTML from '../SanitizedHTML';
import { withFormId } from '../FormIdContext';

const POSITION_TO_DISPLAY = {
    [LEFT]: 'flex-start',
    [CENTER]: 'center',
    [RIGHT]: 'flex-end',
    [FULL]: 'center',
};

const Container = styled.div`
    display: flex;
    justify-content: ${(props) => POSITION_TO_DISPLAY[props.buttonPosition]};
    flex: ${(props) => props.buttonPosition === FULL && '1'};
    margin-left: ${(props) => (props.isFormSubmitting ? 'auto' : 0)};
`;

// @TODO: grab this label from somewhere else.
const SUBMITTING_LABEL = 'Submitting...';

const FormSubmitButton = (props) => {
    const status = props.isSubmitting ? STATUS_LOADING : STATUS_READY;

    const fullWidth = props.buttonPosition === FULL;

    return (
        <Container buttonPosition={props.buttonPosition} isFormSubmitting={props.isSubmitting}>
            <SuiStateButton
                type="submit"
                label={<SanitizedHTML innerHtml={props.children} />}
                labelLoading={SUBMITTING_LABEL}
                status={status}
                disabled={props.isSubmitting}
                fullWidth={fullWidth}
            />
        </Container>
    );
};

FormSubmitButton.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    buttonPosition: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const { formId } = props;
    const buttonPosition = getButtonPosition(state, formId) || DEFAULT_BUTTON_POSITION;

    return {
        isSubmitting: getFormSubmitting(state),
        buttonPosition,
    };
};

export default withFormId(connect(mapStateToProps, {})(FormSubmitButton));
